import React from "react";

import { FormBuilder } from "shared/components";
import { IFormButtons } from "shared/types";
import { IContact } from "shared/types";
import { fields, defaultValues as standardDefaultValues, style } from "./formData";

interface ContactFormProps {
  isSubmitting?: boolean;
  hasError?: boolean;
  defaultValues?: Record<string, any>;
  buttons?: IFormButtons;
  submitMode?: "isDirty";
  resetForm?: boolean;
  inlineForm?: boolean;
  handleSubmit: (contact: IContact) => void;
}

export const ContactForm: React.FC<ContactFormProps> = ({
  resetForm,
  handleSubmit,
  hasError,
  defaultValues = standardDefaultValues,
  ...rest
}) => {
  return (
    <FormBuilder
      fields={fields}
      onSubmit={contact => handleSubmit(contact)}
      defaultValues={defaultValues}
      style={style}
      globalError
      submitMode="isDirty"
      resetForm={resetForm}
      apiErrorMessage={hasError}
      {...rest}
    />
  );
};
